export default {
  'booking.totalsales': 'Общий объем продаж по счетчику',
  'booking.buy_ticket': 'Купить билет',
  'booking.wheretogo': ' Куда бы хотели пойти?',
  'booking.searchflight': 'Поиск рейса',
  'booking.selectflight': 'Выберите рейс',
  'booking.oneway': 'В одну сторону',
  'booking.onewaytrip': 'Поездка в один конец',
  'booking.roundtrip': 'Поездка туда и обратно',
  'booking.multicity': 'Несколько городов',
  'booking.bestguarantee': 'Лучшие тарифы гарантированы онлайн',
  'booking.getdeals': 'Получить предложения',
  'booking.signupnow': 'Зарегистрироваться сейчас',
  'booking.from': 'Из',
  'booking.to': 'До',
  'booking.guest': 'Гост',
  'booking.city': 'Города',
  'booking.Adult': 'Взрослый',
  'booking.adult': 'Взрослый',
  'booking.Child (Age 2-12)': 'Ребенок(возраст 2 - 12)',
  'booking.Infant (Age 0-2)': 'Младенец(возраст 0 - 2)',
  'booking.guestsandcities': 'Гость и Города',
  'booking.startover': 'Начать сначала',
  'booking.showmoredate': 'Показать больше Даты',
  'booking.selectdate': 'Выберите дату',
  'booking.date': 'Дата',
  'booking.changedate': 'Изменить дату',
  'booking.airline': 'Авиакомпании',
  'booking.departs': 'Отправление',
  'booking.arrives': 'Прилеты',
  'booking.duration': 'Продолжительность Полета',
  'booking.travelclass': 'Тип',
  'booking.priceperadult': 'Цена для взрослых',
  'booking.priceperchild': 'Цена для детей',
  'booking.priceperinfant': 'Цена для ребенка',
  'booking.flightnumber': 'Рейс №',
  'booking.remainseat': 'Оставшиеся место',
  'booking.cost': 'Стоймость',
  'booking.showmore': 'Показать больше',
  'booking.birthyear': 'Год рождения',
  'booking.birthmonth': 'Месяц рождения',
  'booking.birthday': 'Дата рождения',
  'booking.passportno': 'Паспорт №',
  'booking.birthcountry': 'Страна рождения',
  'booking.passportcountry': 'Национальность',
  'booking.passportexpireyear': 'год окончания срока',
  'booking.passportexpiremonth': 'месяц окончания срока',
  'booking.passportexpireday': 'день окончания срока',
  'booking.completeform': 'Заполните анкету, чтобы продолжить',
  'booking.changeavatar': 'Сменить аватар',
  'booking.passengerinfo': 'Информация пассажира',
  'booking.isiranian': 'Иранский',
  'booking.othernationality': 'Другие национальности',
  'booking.perviousepassenger': 'Выберите из списка пассажиров',
  'booking.index': 'Индекс',
  'booking.primarytraveler': 'ВИП путешественник',
  'booking.adultinformation': 'Информация для взрослых',
  'booking.childinformation': 'Информация для детей',
  'booking.infantinformation': 'Информация для ребенки',
  'booking.phone': 'номер телефона',
  'booking.totalprice': 'Итоговая цена',
  'booking.stopcount': 'Стоп',
  'booking.airplanetype': 'Самолет',
  'booking.international': 'Международный',
  'booking.domestic': 'внутренний',
  'booking.notexist': 'НЕ СУЩЕСТВУЕТ',
  'booking.noavailableflight': 'НЕТ ДОСТУПНЫХ РЕЙСОВ',
  'booking.departurecities': 'Город отправления',
  'booking.returncities': 'Город возвращения',
  'booking.departuredate': 'Дата отправления',
  'booking.returndate': 'Дата возвращения',
  'booking.departuretime': 'Время отправления',
  'booking.returntime': 'Время возвращения',
  'booking.paynow': 'Оплатить сейчас',
  'booking.sigin': 'Войти',
  'booking.signup': 'Зарегистрироваться',
  'booking.notregister': 'Не зарегистрирован',
  'booking.elevatemembers': 'Поднять Пользователя',
  'booking.departureflightinfo': 'Информация об Отправлении',
  'booking.returnflightinfo': 'информация о Возвращение',
  'booking.previouspassenger': 'Предыдущие пассажиры',
  'booking.hi': 'Привет',
  'booking.travelwith': 'Вы путешествуете с',
  'booking.ticket': 'Ваш билет будет выпущен в ближайшее время',
  'booking.successpayment': 'Ваш платеж прошел успешно',
  'booking.previousepassengerlist': 'Список предыдущих пассажиров',
  'booking.bookingflights': 'Бронирование авиабилетов',
  'booking.flightno': 'Номер рейса',
  'booking.child': 'дети',
  'booking.infant': 'ребенок',
  'booking.male': 'мужчина',
  'booking.female': 'женщина',
  'booking.departureflight': 'Улетающий рейс',
  'booking.returnflight': 'Обратный рейс',
  'booking.showticket': 'билет',
  'booking.cancel': 'Отмена',
  'booking.passengers': 'Пассажиры',
  'booking.returnprice': 'Возвращаемая цена',
  'booking.cancelstatus': 'статус',
  'booking.cancelreason': 'почему вы хотите отменить свой билет?',
  'booking.personalproblem':
    'Личная проблема(на основании правил авиакомпании)',
  'booking.airlineproblem': 'Отмена рейса авиакомпанией',
  'booking.flightproblem': 'Задержка или ранее полет более 2 часа',
  'booking.back': 'назад',
  'booking.nextstep': 'Следующий шаг',
  'booking.previousstep': 'предыдущий шаг',
  'booking.cancelingrules': 'Правила Отмененыи',
  'booking.wait': 'Подождите Пожалуйста......',
  'booking.flights': 'Рейсы',
  'booking.cancelpayment': 'Ваша транзакция не выполнена',
  'booking.refid': 'Ваш код отслеживания',
  'booking.airport': 'Аэропорты',
  'booking.flighttime': 'Время полета',
  'booking.flightstopcount': 'Остановки',
  'booking.morning': 'Утром(С 0 до 8)',
  'booking.noon': 'День(с 8 до 14)',
  'booking.afternoon': 'Во второй половине дня(с 14 до 20)',
  'booking.night': 'Ночь(после 20)',
  'booking.sort': 'Сортировка',
  'booking.sortbyprice': 'По цене',
  'booking.sortbytime': 'По времени',
  'booking.nonstop': 'Прямой',
  'booking.onestop': 'Одна остановка',
  'booking.morethanonestop': 'Больше чем одна остановка',
  'booking.origin': 'происхождения',
  'booking.destination': 'Место назначения',
  'booking.startdate': 'Дата начала',
  'booking.enddate': 'Дата окончания',
  'booking.search': 'Поиск',
  'booking.filter': 'фильтр',
  'booking.agree': 'Я согласен',
  'booking.cancelrules': 'Правила Отмененыи',
  'booking.flightscount': 'Авиабилеты найдены!',
  'booking.clearfilter': 'Чисто',
  'booking.gifavatar': 'Gif Аватар',
  'booking.avatar': 'Аватар',
  'booking.notfound': 'Город не найден',
  'booking.nextyear': 'Следующий год',
  'booking.previousyear': 'Предыдущий год',
  'booking.details': 'Детали',
  'booking.adultprice': 'Цена за взрослого',
  'booking.sortby': 'Сортировать по',
  'booking.bydescendingprice': 'продолжительность',
  'booking.byascendingduration': 'продолжительность',
  'booking.bydescendingduration': 'Полета',
  'booking.byascendingprice': 'цена',
  'booking.bydescendingtime': 'время отправления',
  'booking.byascendingarrivetime': 'время прибытия',
  'booking.bydescendingarrivetime': 'время прибытия',
  'booking.byascendingtime': 'время отправления',
  'booking.bydescendingpoint': 'точка',
  'booking.byascendingpoint': 'точка',
  'booking.justthis': 'Только',
  'booking.searchpassenger': 'Вы ищете ...',
  'booking.edit': 'Редактировать',
  'booking.select': 'Выбрать',
  'booking.gotoday': 'Ехать Сегодня',
  'booking.pricedetail': 'Детали Цены',
  'booking.passengertype': 'Тип',
  'booking.fareprice': 'Стоимость Проезда',
  'booking.tax': 'Налог',
  'booking.allairport': ' ( Все Аэропорты )',
  'booking.moneyunit': 'Все Цены $',
  'booking.noseatresult': 'нет мест',
  'booking.today': 'Сегодня',
  'booking.terminal': 'Терминал',
  'booking.sumprice': 'Итоговая цена',
  'booking.sameairport':
    'Пожалуйста, Введите Уникальные «От» и «До» Аэропортов.',
  'booking.stopin': 'Стоп в',
  'booking.megaleapyearsale': 'Mega Leap Year Продажа',
  'booking.planasunnyd1': 'Спланируйте солнечный отпуск сейчас и сэкономьте с',
  'booking.planasunnyd2': 'супер редкие тарифы 29 %.',
  'booking.restrictionsapply': 'Ограничения применяются',
  'booking.grabaseat': 'Схватить место',
  'booking.enjoywithbestfriends': 'Наслаждайтесь с лучшими друзьями',
  'booking.helpafriendd1':
    'Помогите друзьям расстаться с их программой лояльности',
  'booking.helpafriendd2': 'И набрать призовые очки',
  'booking.termsandconditionsapply': 'Принять условия',
  'booking.bookhotels': 'Бронирование Отелей',
  'booking.booktours': 'Забронировать туры',
  'booking.traveldate': 'Дата поездки',
  'booking.invoice': 'Счет',
  'booking.totalamount': 'Итоговая цена',
  'booking.showreserve': 'Показать резерв',
  'booking.takeofffaster': 'Сними Быстрее',
  'booking.earn10kpointsd1': 'Заработайте 10 тысяч очков с туристом IAM',
  'booking.earn10kpointsd2': 'Visa карты',
  'booking.learnmore': 'УЗНАТЬ БОЛЬШЕ',
  'booking.swipeforthesky': 'ПОКРЫТИЕ ДЛЯ НЕБА',
  'booking.getsetforamorerewardingexperienceonthegroundandinthesky':
    'Получите удовольствие от поездки на земле и в небе с новой картой IAM TOURIST Visa Signature®.',
  'booking.firstoneonfirstoneoff': 'ПЕРВЫЙ ВКЛ, ПЕРВЫЙ ВЫКЛ',
  'booking.inahurry':
    'В спешке? Make a “B” line for the car with a preferred main cabin seat towards the front of the plane, или побалуйте себя приоритетной безопасностью и посадкой за небольшую плату.',
  'booking.feeltheupgrade': 'Почувствуй обновление.',
  'booking.travelinstylewithextralegroom':
    'Путешествуйте стильно с дополнительным пространством для ног, приоритетной посадкой и охраной, и многое другое в Main Cabin Select.Живи, путь вверх.',
  'booking.takethefasttrack': 'БРАТЬ Fast Track.',
  'booking.breezethroughsecuritylikeyouowntheplace':
    'Проходите сквозь безопасность, как будто вы владеете домом, с помощью ускоренного скрининга TSA Pre√ ™.Узнайте, как пользоваться преимуществами.',
  'booking.corporaterewards': 'КОРПОРАТИВНЫЕ НАГРАДЫ',
  'booking.abetterflighttoyournextmeetingdoesn’thavetobeanextravagance':
    'Лучший полет к вашей следующей встрече не должен быть расточительством.Elevate, Inc., наша корпоративная программа поощрений, которая дает вашему бизнесу немного возврата за то, что вы тратите на путешествия.',
  'booking.packyourpoints': 'УПАКОВАТЬ ВАШИ БАЛЛЫ.',
  'booking.livelargeat35,000feet':
    'Жить большой на 35 000 футов.Присоединяйтесь к Elevate и начните набирать очки, льготы и поощрительные полеты без отключений.',
  'booking.price': 'Цена',
  'booking.allpassengerprice': 'Общая стоимость для всех пассажиров',
  'booking.baggages': 'багаж',
  'booking.orderdate': 'Дата заказа',
  'booking.passengername': 'ИМЯ',
  'booking.cancelticket': 'ОТМЕНА БИЛЕТА',
  'booking.operatedairline': 'Авиакомпания',
  'booking.count': 'подсчет',
  'booking.departureflighttime': 'Время Отправления',
  'booking.returnflighttime': 'Время Возврата',
  'booking.returnstopcount': 'Возврат Остановок',
  'booking.pc': 'Щт',
  'booking.kg': 'Кг',
  'booking.cabin': 'Кабин',
  'booking.layoverairports': 'Аэропорт Ожидании',
  'booking.includeairports': 'Включенные Аэропорты',
  'booking.departduration': 'Продолжительность Отправления',
  'booking.returnduration': 'Продолжительность Возвращении',
  'booking.nights': 'Ночи',
  'booking.nightcount': 'Ночи',
  'booking.showflightdetail': 'Показать Детали Полета',
  'booking.toman': 'IRT',
  'booking.free': 'Бесплатно',
  'booking.hour': 'Час',
  'booking.minutes': 'Минут',
  'booking.and': 'и',
  'booking.nobaggage': 'Без Багажа',
  'booking.mainterminal': 'Главный Терминал',
  'booking.shamsi': 'Джалали',
  'booking.miladi': 'Григорианский',
  'booking.adultageerror': 'Взрослый возраст более 12 лет',
  'booking.childageerror': 'Взрослый возраст должен быть более 12 лет',
  'booking.infantageerror': 'Младенческий возраст должен быть менее 2 лет',
  'booking.passenger': 'Пассажир',
  'booking.important': 'Важно!',
  'booking.policy':
    'Отметьте здесь, чтобы указать, что вы прочитали и согласны с условиями',
  'booking.identifynote':
    'Полное Имя пассажира должно быть написано на Английском языке в точности так, как указано в паспорте',
  'Booking.validpassportdate':
    'Срок Действия вашего Паспорта должен быть более 6 месяцев',
  'booking.adt': 'ADT',
  'booking.chd': 'CHD',
  'booking.inf': 'INF',
  'booking.departure': 'Отправление',
  'booking.return': 'Возврат',
  'booking.allflightinformation': 'Информация о всех рейсах',
  'booking.notavailable': 'N / A',
  'booking.previousemonth': 'Предыдущий месяц',
  'booking.nextmonth': 'Следующий месяц',
  'booking.passportexpiredate': 'Срок Действия Паспорта',
  'booking.arrivein': 'Прибытие в',
  'booking.nextdays': 'Следующий День',
  'booking.clearallfilter': 'Очистить Все',
  'Booking.duplicatepassenger':
    'Национальный код или Номер паспорта дублируется',
  'booking.changecontact': 'Информация о билете отправить на : ',
  'booking.customeragreement': 'Клиентское Соглашение',
  'booking.flightrules': 'Правила Полета',
  'booking.changecontacttitle': 'Изменить Контактную Информацию',
  'booking.fullname': 'Полное Имя',
  'booking.address': 'Адрес',
  'booking.change': 'Изменение',
  'booking.firstname': 'Имя',
  'booking.lastname': 'Фамилия',
  'booking.departureairport': 'Отправления',
  'booking.arrivalairport': 'Аэропорт Прибытия',
  'booking.previousedays': 'Прошлый День',
  'booking.day': 'День',
  'booking.month': 'Месяц',
  'booking.year': 'Год',
  'booking.changepassenger': 'Изменить Количество Пассажиров',
  'booking.editdepartcity': 'Изменить Город Происхождения',
  'booking.editdestinationcity': 'Изменить Город Назначения',
  'booking.editdepartdate': 'Изменить Дату Происхождения',
  'booking.editdestinationdate': 'Изменить Дату Назначения',
  'booking.changepassengernotify':
    'Если вы поменяете пассажира на этом шаге, вы вернетесь к шагу поиска рейса!!!!',
  'booking.edittooltip':
    'Пожалуйста, нажмите на желаемую собственность, чтобы изменить свойства полета',
  'booking.books': 'Забронировано',
  'booking.reserves': 'Брони',
  'booking.of': 'Из',
  'booking.canceled': 'Отменен',
  'booking.history': 'История',
  'booking.searchpassengerinfo':
    'Имя, Номер паспорта, Национальный код, Номер билета, PNR',
  'booking.issued': 'ВЫПУЩЕН',
  'booking.bought': 'ВЫПУЩЕН',
  'booking.serviceType': 'Тип Обслуживания',
  'booking.serviceName': 'Авиабилет, Гостиница, Поезд ...',
  'booking.invoicenumber': 'Номер Инвойса',
  'booking.chooseticket': 'Какой билет вы хотите Отменить?',
  'booking.cancelreturn': 'Отменить только Обратный билет',
  'booking.cancelroundtrip': 'Отменить все Билеты',
  'booking.addflight': 'Добавить Рейс',
  'booking.showmulticity': 'Показать Все Рейсы',
  'booking.view': 'Смотреть',
  'booking.takeofffrom': 'Время Взлета с',
  'booking.at': 'При',
  'booking.tripsi': 'Трипси',
  'booking.includetax': 'Цена включает налоги и все расходы авиакомпании',
  'booking.paymentsummery': 'Сводка Платежей',
  'booking.counter': 'Счетчик',
  'booking.sum': 'Сумма',
  'booking.transaction': 'Отчет о Транзакциях',
  'booking.countercommission': 'Отчет комиссии по счетчикам',
  'booking.domesticflightscount': 'Количество внутренних рейсов',
  'booking.internationalflightscount': 'Количество международных рейсов',
  'booking.createdate': 'Дата Создания',
  'booking.income': 'Доход',
  'booking.notwithdrawincome': 'Не Снимать Доход ',
  'booking.notwithdrawpoint': 'Не Снимать Балл',
  'booking.withdrableincome': 'Выводимый Доход ',
  'booking.withdrablepoint': 'Точка Выхода',
  'booking.pendingincome': 'Ожидаемый Доход ',
  'booking.pendingpoint': 'Ожидающая Точка',
  'booking.collectedpoint': 'Собранная Точка ',
  'booking.spentpoint': 'Израсходованные Баллы',
  'booking.paymentstatus': 'Статус Платежа',
  'booking.withdrawdate': 'Дата Снятия',
  'booking.countername': 'Имя Счетчика',
  'booking.canceleditting': 'Отмена',
  'booking.nationalcode': 'Национальный',
  'booking.previousweek': 'Предыдущая неделя',
  'booking.nextweek': 'Следующая неделя',
  'booking.allprice': 'Все цены указаны в IRT',
  'booking.allpriceisrial': 'Все цены указаны в IRR',
  'booking.showallcalendar': 'Показать цену на матрице',
  'booking.hideallcalendar': 'Скрыть цену на матрице',
  'booking.multicitytrip': 'Поездка в нескольких городов',
  'booking.selectstakeholder': 'Выберите вашу заинтересованную Сторону',
  'booking.changestakeholder': 'Смена заинтересованного лица',
  'booking.ticketwithoutprice': 'Билет без цены',
  'booking.markupticket': 'Билет с наценкой',
  'booking.orginalticket': 'Оригинальный билет',
  'booking.markup': 'Наценка',
  'booking.removeflight': 'Удалить рейс',
  'booking.continueguest': 'Продолжить как гость',
  'booking.hotel': 'Отель',
  'booking.trackorder': 'Отслеживать заказы',
  'booking.trackingcode': 'Код отслеживания',
  'booking.searchyourorders': 'Поиск Ваших Заказов',
  'booking.panel': 'Панель',
  'booking.required': 'ТРЕБУЕТСЯ',
  'booking.baggagerules': 'Правила провоза багажа',
  'booking.userpoint': 'Производная Награда',
  'booking.userpoint': 'Награда',
  'booking.notresult': 'Код отслеживания недействителен',
  'booking.attachpassport': 'Загрузить паспорт ...',
  'booking.payhint':
    'Пожалуйста, примите правила, чтобы продолжить Пожалуйста, заполните контактную информацию эмитента.Пожалуйста, заполните контактную информацию эмитента.',
  'booking.completecontactdescription':
    'Пожалуйста, заполните контактную информацию эмитента тикера.',
  'booking.updatepassenger': 'Обновить информацию о пассажире',
  'booking.paylater': 'Оплатить позже',
  'booking.pnr': 'PNR',
  'booking.penaltyprice': 'Цена Штрафа',
  'booking.sumcancelprice': 'Общая возвращаемая сумма',
  'booking.paymenttype': 'Тип Оплаты',
  'booking.chargecredit': 'Зарядить мой кредит',
  'booking.chargecreditinfo':
    'Сумма будет списана с вашего счета в амутсейр на срок до 7 рабочих дней.',
  'booking.deposit': 'Депозит на банковскую карту',
  'booking.depositinfo':
    'Сумма будет рассчитана на банковский счет, с которого была совершена покупка, максимум до 7 рабочих дней.',
  'booking.cancelmessage': 'Ваш запрос был успешно удален',
  'booking.downloadticket': 'Скачать билет',
  'booking.rerefundable': 'Не возвращается',
  'booking.sendrequest': 'Отправить запрос',
  'booking.withdrawtype': 'Тип вывода',
  'booking.hours': 'Часы',
  'booking.before': 'Перед полетом',
  'booking.flight': 'Рейс',
  'booking.exacttime': 'В Полдень',
  'booking.until': 'До',
  'booking.afterflight': 'После Полета',
  'booking.beforeflight': 'Перед Полетом',
  'booking.after': 'До',
  'booking.fromhours': 'От',
  'booking.sendproblem': 'Отправить Проблему',
  'booking.callsupport':
    'Произошла ошибка при оформлении билетов, обратитесь в службу поддержки',
  'booking.nocancelrules': 'Правило полета не найдено',
  'booking.andhigher': 'И выше',
  'booking.toprice': 'в',
  'booking.searchtimeout': 'Хотите еще раз поискать этот рейс?',
  'booking.searchtime': 'Время поиска ...',
  'booking.searchagaininfo': 'Время искать это',
  'booking.searchagaininfomsg': 'рейс завершен',
  'booking.searchagian': 'да',
  'booking.startagain': 'нет',
  'booking.retrivedocument': 'Получение документа ...',
  'booking.printticket': 'Распечатать билет',
  'booking.forthepassenger': 'Для пассажира',
  'booking.flightticket': 'Авиабилет',
  'booking.ticketno': 'Билет №',
  'booking.deptime': 'dep Time',
  'booking.cancelterm':
    '1- Условия отмены рейсов CHARTER зависят от правил провайдера. Это означает, что он никогда не может быть отменен.',
  'booking.cancelrulehint':
    '2- Стоимость отмены зависит от правил авиакомпании.',
  'booking.attention':
    'Внимание: Пассажирам необходимо явиться в аэропорт за 2 часа до вылета.',
  'booking.valididentify':
    '3- Пожалуйста, имейте при себе действительные документы, удостоверяющие личность, такие как удостоверение личности, свидетельство о рождении или паспорт.',
  'booking.online': 'Онлайн',
  'booking.selectcountry': 'Выберите страну',
  'booking.calendar': 'Календарь',
  'booking.countercommissionreport': 'Отчет счетной комиссии',
  'booking.hasusername': 'У вас есть имя пользователя ? ',
  'booking.nousername': 'Нет имени пользователя ? ',
  'booking.signuporguest': '(Регистрация или Гость)',
  'booking.guestuser': 'Гостевой пользователь',
  'booking.notuserbefore': 'Зарегистрируйтесь сейчас и получайте баллы',
  'booking.reservationfail': 'Невозможно забронировать этот рейс',
  'booking.reservation': 'На этот рейс возможно временное бронирование',
  'booking.reservationerror': 'Ошибка бронирования!',
  'booking.passengererror': 'Ошибка информации о пассажире !',
  'booking.passengerInformationHint':
    'Пожалуйста, проверьте информацию о пассажирах....',
  'booking.displayticket': 'Как отображать билеты',
  'booking.selectcustomer': 'Выберите клиента',
  'booking.asacustomer': 'Kunden zuweisen',
  'booking.changeticketprice': 'Изменить вид цены билета',
  'booking.save': 'Спасти',
  'booking.fromwallet': 'Бумажник',
  'booking.fromcredit': 'Кредит',
  'booking.frompoint': 'Точка',
  'booking.usederik': 'Оплатите стоимость билета своим дериком',
  'booking.yourderik': 'Твой Дерик : ',
  'booking.equivalentprice': 'Эквивалентная Цена',
  'booking.importpnr': 'Импортный ПНР',
  'booking.pnrhint': 'Выберите вашу систему',
  'booking.pnrsteps': 'Чтобы использовать PNR, выполните следующие действия.',
  'booking.enteryour': '1- Enter to your Amadeus panel',
  'booking.openreference': '2- Make your reservation in Amadeus panel. ',
  'booking.pnr3': '3- Enter the passenger passport information completely. ',
  'booking.entercommand':
    '4-Enter the following command code and then press enter key. ',
  'booking.savepnr': '5-Save your PNR and press enter key. ',
  'booking.pnr6':
    '6- In Tripsi page, enter your PNR number in the reference number section. ',
  'booking.pnr7': '7- In the Passenger Last Name field, enter it. ',
  'booking.pnr8': '8- Click the booking button. ',
  'booking.pnr9': '9- Go to the payment page after checking the information. ',
  'booking.pnr10': '10- Your ticket has been issued. ',

  'booking.laststep':
    'Теперь вы можете ввести свою ссылку в поле ниже и выполнить шаги экспорта. ',
  'booking.leadlastname': 'Фамилия основного пассажира',
  'booking.buyer': 'Покупатель',
  'booking.pnrnotfound': 'Ничего не найдено',
  'booking.usepnr': 'Импортировать PNR и просмотреть',
  'booking.uploadpassporterror': 'Информация о паспорте неразборчива',
  'booking.servererror': 'На сервере проблема',
  'booking.accessdenied': 'доступ запрещен',
  'booking.newpassenger': 'Добавить нового пассажира',
  'booking.errormorepassenger': 'Вы выбрали больше пассажиров',
  'booking.passengertypeerror': 'Неверный тип пассажира',
  'booking.chooseallpassenger': 'Пожалуйста, выберите всех пассажиров',
  'booking.checkpassport':
    'После загрузки паспортных данных проверьте свои данные.',
  'booking.apply': 'Подать Заявление',
  'booking.flightinformation': 'Информация о полете',
  'booking.adultticketprice': 'Взрослый билет',
  'booking.childticketprice': 'Детский билет',
  'booking.infantticketprice': 'Детский билет',
  'booking.airplane': 'Самолет',
  'booking.time': 'Время',
  'booking.charter': 'Устав',
  'booking.systemic': 'Системный',
  'booking.type': 'Тип',
  'booking.ticketprice': 'Цена Платежа',
  'booking.pnrcode': 'ваш PNR: ',
  'booking.selectpayment': 'Пожалуйста, выберите способ оплаты',
  'booking.temporaryreservation': 'Временное',
  'booking.direction': 'Направление',
  'booking.passengercount': 'Количество пассажиров',
  'booking.reservesuccess': 'Ваш билет был временно забронирован',
  'booking.passengertotalprice': 'Общая стоимость пассажиров',
  'booking.stopduration': 'продолжительность остановки',
  'booking.invalidbirthdate': 'Неверная дата рождения',
  'booking.invalidexpiredate': 'Недействительный срок действия',
  'booking.fullbirthdate': 'Выберите дату рождения полностью',
  'booking.fullexpiredate': 'Выберите дату окончания срока действия полностью',
  'booking.creditpayment': 'Платеж с вашего кредита прошел успешно',
  'booking.walletpatment': 'Платеж из вашего кошелька прошел успешно',
  'booking.pointpayment': 'Платеж с вашей точки прошел успешно',
  'booking.tickettimelimit': 'Срок билета',
  'booking.onbehalf': 'on behalf',
  'booking.expirereserve': 'Истекший',
  'booking.person': 'Человек',
  'booking.startorderdate': 'Дата начала заказа',
  'booking.endorderdate': '  Дата окончания заказа',
  'booking.missflight': 'Я пропустил рейс',
  'booking.multiairline': 'Мульти авиакомпания',
  'booking.in': 'в',
  'booking.afterdiscount': 'После скидки',
  'booking.editissuer': 'Изменить контактную информацию о проблеме',
  'booking.referencenumber': 'Номер ссылки',
  'booking.flight': 'Полет',
  'booking.train': 'Тренироваться',
  'booking.bus': 'Автобус',
  'booking.hotel': 'Отель',
  'booking.referencenumber': 'номер ссылки',
  'booking.train': 'тренироваться',
  'booking.bus': 'автобус',
  'booking.economy': 'Экономика',
  'booking.business': 'Бизнес',
  'booking.first': 'Первый',
  'booking.allcabinclasses':
    'На выбранном вами маршруте будут отображены все классы полетов.',
  'booking.findtrip': 'найти поездку',
  'booking.selectacity': 'Выберите город',
  'booking.destinations': 'Направления',
  'booking.london': 'Лондон',
  'booking.rome': 'Рим',
  'booking.istanbul': 'Стамбул',
  'booking.deletePassengerTitle': 'Удалить пассажира',
  'booking.invalidnationalcode': 'Неверный национальный код',
  'booking.showgatewayerror': 'показать ошибку шлюза',
  'booking.alternativefrom': 'От',
  'booking.alternativeto': 'Кому',
  'booking.commingsoon': 'скоро',
  'booking.searchorigin': 'Искать источник',
  'booking.searchdestination': 'Искать место назначения',
  'booking.plannedflight': 'Запланированный рейс',
  'booking.yesterday': 'Вчера',
  'booking.twodaysago': 'Два дня назад',
  'booking.englishname': 'Имя (на английском)',
  'booking.englishlastname': 'Фамилия (на английском языке)',
  'booking.rialtotalprice': 'Итоговая цена(Rial)',
  'booking.gotosearchflight': 'Перейти к поиску рейса',
  'booking.seat': 'место',
  'booking.englishticket': 'Английская версия билетов',
  'booking.persianticket': 'Персидская версия билета',
  'booking.searchmypassenger': 'поиск от предыдущих пассажиров',
  'booking.selectairporterror':
    'Выберите пункт отправления и пункт назначения сверху',
  'booking.providergateway': 'Шлюзы провайдеров',
  'booking.seniorageerror':
    'Возраст пожилого человека должен быть старше 60 лет',
  'booking.toddlerageerror': 'возраст малыша должен быть меньше 2 лет',
  'booking.noresultwithfilter':
    'С выбранным фильтром ничего не найдено, пожалуйста, измените его',
  'booking.expirereservation': 'Срок действия бронирования истек',
  'booking.unpaidreservation': 'неоплаченные бронирования',
  'booking.selectbooking': 'Пожалуйста, выберите билеты для оплаты',
  'booking.mobileformaterror': 'Мобильный формат недействителен',
  'booking.poweredby': 'Powered by',
  'booking.hoteldescription': 'Забронируйте отель сейчас со скидкой 30%',
  'booking.tickettitle': 'проездной билет :',
  'booking.stopdurationin': 'Продолжительность остановки через',
  'booking.contactInfo': 'Контактная информация для выдачи',
  'booking.expireDate': 'Срок действия',
  'booking.pnrdesc': 'Заказывайте в Amadeus и оформляйте здесь.',
  'booking.officeid': 'Идентификатор офиса',
  'booking.pnrhelp': 'Руководство пользователя',
  'booking.ticketinfo': 'Детали билетов',
  'booking.saletotalamount': 'Importo totale vendita',
  'booking.traveldatetime': 'Дата поездки',
  'booking.sale': 'Sale',
  'booking.buy': 'Buy',
  'booking.pnrdesc': 'Заказывайте в Amadeus и оформляйте здесь.',
  'booking.officeid': 'Идентификатор офиса',
  'booking.pnrhelp': 'Руководство пользователя',
  'booking.ticketinfo': 'Детали билетов',
  'booking.emailticket': 'Электронный билет',
  'booking.changeticketprice': 'Изменить цену',
  'booking.backpreviouspage': 'назад',
  'booking.changecabinclass': 'Изменить класс кабины',
  'booking.changecabinclassnotify':
    'Если вы измените класс салона на этом шаге, вы вернетесь к шагу поиска рейса !!!!',
  'booking.ticketprice': 'Цена билета',
  'booking.payableamount': 'подлежащая оплате сумма',
  'booking.showflight': 'Показать рейс',
  'booking.tripdirection': 'Направление поездки',
  'booking.selectpaymenttype': 'Выберите тип оплаты',
  'booking.title': 'заглавие',
  'booking.male': 'Господин',
  'booking.female': 'миссис',
  'booking.selectpaymenttype': 'Выберите тип оплаты',
  'booking.mr': 'Господин',
  'booking.mrs': 'госпожа',
  'booking.yourchoice': 'На ваш выбор',
  'booking.result': 'Результат',
  'booking.changeflight': 'изменить маршрут полета',
  'booking.arrivetime': 'Время прибытия',
  'booking.sortbyarrivetime': 'Сортировать по времени прибытия',
  'booking.sortbyduration': 'Ordina per durata',
  'booking.sortbypoint': 'Сортировать по пунктам',
  'booking.tickettype': 'Тип билета',
  'booking.selectall': 'выбрать все',
  'booking.addpassenger': 'Добавить пассажира',
  'booking.textpassenger':
    'Через форму ниже вы можете ввести информацию о вашем пассажире и зарегистрировать информацию в конце.',
  'booking.showavailableflight': 'Показать доступные рейсы',
  'booking.roomtype': 'Тип номера',
  'booking.extrabed': 'Дополнительная кровать',
  'booking.numberofrooms': 'Количество комнат',
  'booking.addnewroom': 'Добавить новую комнату',
  'booking.picturesofroom': 'Фотографии комнаты',
  'booking.availsflight': 'Доступный рейс',
  'booking.events': 'События в календаре',
  'booking.eventsinfo': 'Просмотреть события каждой выбранной страны',
  'booking.want': 'я хочу',
  'booking.setmaxprice': 'установить максимальную цену',
  'booking.selectcity':
    'Пожалуйста, сначала выберите аэропорты отправления и назначения',
  'booking.allcabinselected':
    'На внутренних рейсах будут искать все классы полетов',
  'booking.all': 'Все',
  'booking.passportImage': 'Изображение паспорта',
  'booking.passporthint':
    'Пожалуйста, загрузите изображение четко и по образцу размером 700*500',
  'booking.showsample': 'посмотреть образец паспорта',
  'booking.country': 'Страна',
  'booking.originCity': 'Город происхождения',
  'booking.destinationCity': 'Город назначения',
  'booking.welcometripsi': 'Добро пожаловать в Трипси',
  'booking.PassengerNameInEnglish': 'Имя пассажира на английском языке',
  'booking.PassengerLastNameInEnglish': 'фамилия на английском',
  'booking.NationalityOfThePassenger': 'Национальность пассажира',
  'booking.genderOfThePassenger': 'Пол пассажира',
  'booking.totalpriceofpassengers': ' Общая стоимость пассажира ',
  'booking.travelerdetails': 'Данные путешественника',
  'booking.senior': 'Старший',
  'booking.toddler': 'Ребёнок-кресло',
  'booking.parishotel': 'Paris Hotel',
  'booking.paymentprice': 'Цена платежа',
  'booking.tourdescription':
    '21-дневный тур по Европе на Новруз 1401. При регистрации до конца декабря скидка 5%',
  'booking.reservebefore': 'этот рейс забронирован до',
  'booking.editpassengersinfo': 'Редактировать информацию о пассажирах',
};
